import React from 'react'
import Navigation from '../components/Navigation'
import Gallery from '../components/CollectionGallery'
import { useStaticQuery, graphql, StaticQuery } from "gatsby"

import '../stylesheets/reset.css'
import '../stylesheets/style.css'

const Collection = ({ pageContext: { data, slug } }) => {
  console.log('collection props',data,slug)

  const navigation = useStaticQuery(graphql`
    query collection {
      allStrapiCollection {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  `)

  return (
    <div id='root'>
      <Navigation allStrapiCollection={navigation.allStrapiCollection}/>
      <Gallery images={data.Images}/>
    </div>
  )
}

export default Collection

